import styled from "styled-components";

const Card = styled.div`

background:#20263A;

padding:24px;

border-radius:24px;

color:#F8FAFC;

`;

const Grid=styled.div`

display:grid;

grid-template-columns:repeat(auto-fit,minmax(160px,1fr));

gap:16px;

margin-top:20px;

`;

const Item=styled.button`

padding:18px;

border:none;

border-radius:18px;

background:#293247;

color:white;

font-weight:700;

cursor:pointer;

transition:.25s ease;

&:hover{

transform:translateY(-3px);

background:#3B82F6;

box-shadow:
0 8px 20px rgba(59,130,246,.35);
}

`;

export default function QuickActionsCard({

onEntrenar,

onPerfil,

onCerrarSesion,

perfilActivo,

onCambiarPerfil,

onGrupos,

onMisMetas

}){

return(

	

<Card>

<h2
style={{
    margin:0,
    color:"#F8FAFC"
}}
>
⚡ Acciones rápidas
</h2>

<Grid>

<Item onClick={onEntrenar}>

🚀 Entrenar

</Item>

<Item onClick={onMisMetas}>

🌌 Mis Metas

</Item>

<Item onClick={onGrupos}>

👥 Grupos

</Item>

<Item>

⚔ Arena

</Item>

<Item>

🎁 Recompensas

</Item>

<Item onClick={onPerfil}>

👤 Perfil

</Item>

<Item>

⭐ Premium

</Item>


{
perfilActivo==="estudiante"

?

<Item
onClick={()=>onCambiarPerfil("profesor")}
>

👨‍🏫 Cambiar a profesor

</Item>

:

<Item
onClick={()=>onCambiarPerfil("estudiante")}
>

🎓 Cambiar a estudiante

</Item>

}

<Item onClick={onCerrarSesion}>

🚪 Cerrar sesión

</Item>

</Grid>

</Card>

);

}

const SummaryOverlay = styled.div`
	position: fixed;
	inset: 0;

	background:
		rgba(0,0,0,0.92);

	z-index: 8000;

	display: flex;
	align-items: center;
	justify-content: center;

	padding: 1rem;

	backdrop-filter: blur(8px);
`;
